import { HelpCircle, Search, Link2, Hammer, MessageCircle } from "lucide-react";
import { SectionHeading } from "@/components/common/SectionHeading";
import { Reveal } from "@/components/common/Reveal";

const STAGES = [
  { title: "Question", icon: HelpCircle, color: "bg-lemon", text: "Students start from a real question that matters, shaped together with their teacher." },
  { title: "Investigate", icon: Search, color: "bg-mint", text: "With teacher guidance, they research, test ideas and gather evidence." },
  { title: "Connect", icon: Link2, color: "bg-sky", text: "They link what they learn across subjects to see the bigger picture." },
  { title: "Create", icon: Hammer, color: "bg-blush", text: "They make something meaningful: a model, a solution, a presentation or a campaign." },
  { title: "Reflect", icon: MessageCircle, color: "bg-lavender", text: "They share their work, receive feedback and decide what to improve next." },
];

export const InquiryJourney = () => (
  <section className="bg-cream-deep/60 section-y-card rounded-[40px] mx-3 sm:mx-6" aria-labelledby="journey-title" data-testid="inquiry-journey-section">
    <div className="container-x">
      <SectionHeading id="journey-title" eyebrow="How learning unfolds" title="Learning through inquiry & real-world projects"
        intro="Inquiry at MUCCI is teacher-guided, not left to chance. Each project moves through five stages and ends with an outcome students are proud to share." />
      <ol className="relative mt-14 grid gap-6 lg:grid-cols-5">
        <div aria-hidden="true" className="absolute left-0 right-0 top-8 hidden border-t-2 border-dashed border-ink/20 lg:block" />
        {STAGES.map(({ title, icon: Icon, color, text }, i) => (
          <Reveal as="li" key={title} delay={i * 0.08} className="relative flex gap-5 lg:block">
            <span className={`relative z-10 grid h-16 w-16 shrink-0 place-items-center rounded-full border-4 border-cream ${color}`} data-testid={`journey-stage-${i + 1}`}>
              <Icon className="h-6 w-6" aria-hidden="true" />
            </span>
            <div className="lg:mt-5">
              <p className="text-xs font-bold uppercase tracking-[0.14em] text-ink-muted">Stage {i + 1}</p>
              <h3 className="mt-1 text-2xl font-semibold">{title}</h3>
              <p className="mt-2 text-ink-soft leading-relaxed">{text}</p>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
